import {
  Box,
  Button,
  Container,
  FormControl,
  FormHelperText,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export const SignUpValidation = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const hasAttemptedValidation = useRef(false);

  const selector = searchParams.get("s");
  const verifier = searchParams.get("v");

  useEffect(() => {
    if (hasAttemptedValidation.current) {
      return;
    }

    const validateEmail = async () => {
      if (!selector || !verifier) {
        setError("Invalid activation link format.");
        setLoading(false);
        return;
      }

      hasAttemptedValidation.current = true;

      try {
        const res = await axios.post("/api/v2/validate-email/", {
          s: selector,
          v: verifier,
        });

        if (res.data.access && res.data.refresh) {

          localStorage.clear();
          sessionStorage.clear();

          localStorage.setItem("access_token", res.data.access);
          localStorage.setItem("refresh_token", res.data.refresh);

          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${res.data.access}`;

          window.location.href = "/";
        } else {
          setSuccess(true);
          setLoading(false);
        }
      } catch (error) {
        let errorMessage =
          "Activation link expired or invalid. Please request a new link.";

        if (error.response?.data?.details) {
          errorMessage = error.response.data.details;
        }

        setError(errorMessage);
        setLoading(false);
      }
    };

    validateEmail();
  }, [selector, verifier]);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        window.location.href = "/login";
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <Container
      maxW="100%"
      bgColor="#FFFFFF"
      h="100vh"
      p={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="750px"
    >
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <Box minW={{ base: "90%", md: "468px" }}>
          <Stack
            spacing={4}
            p="1.75rem"
            width="90vw"
            maxW="438px"
            backgroundColor="#FFFFFF"
            boxShadow="0px 8px 16px 0px #00000026"
            borderRadius="5px"
            alignItems="center"
          >
            {loading && (
              <Text fontSize="24px" fontWeight={400}>
                Activating your account...
              </Text>
            )}

            {success && (
              <>
                <Text fontWeight={500} fontSize="24px" color="green.500">
                  Account Activated Successfully!
                </Text>
                <Text fontSize="16px" color="#666666" textAlign="center">
                  Your account has been activated. If you are not automatically
                  redirected in 5 seconds, please click the button below.
                </Text>
                <Button as={Link} href="/login" colorScheme="blue" size="lg">
                  Go to Login
                </Button>
              </>
            )}

            {error && (
              <>
                <Text fontWeight={500} fontSize="18px" color="red.500">
                  {error}
                </Text>
                <FormControl w="80vw" maxW="374px">
                  <FormHelperText
                    textAlign="center"
                    fontSize="16px"
                    fontWeight={400}
                    color="#666666"
                  >
                    Please try requesting a new activation link if this problem
                    persists.
                  </FormHelperText>
                </FormControl>
              </>
            )}
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
};

export default SignUpValidation;
